module.exports = __webpack_public_path__ + "media/music6.5d1bc4e3.mp3";